import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { filterPrimaryConfig } from 'page/layout-areas.js';
import * as React from 'react';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { isLargeView, SCREEN_SIZES } from 'utilities/media-queries.js';
import { RenderLargeLayout } from './five-up-large.js';
import { RenderSmallLayout } from './five-up-small.js';

const FiveUpPrimarySection = ({ data }: { data: ILayoutConfig }) => {
  const columnLayout = React.useContext(ScreenSizeContext);
  return <FiveUpPrimarySectionCore columnLayout={columnLayout} data={data} />;
};

const FiveUpPrimarySectionCore = ({ data, columnLayout }: { data: ILayoutConfig; columnLayout: SCREEN_SIZES }) => {
  const { primary } = data;

  const filteredPrimaryConfig = React.useMemo(
    () => filterPrimaryConfig(primary.slots, columnLayout),
    [primary.slots, columnLayout],
  );

  if (data) {
    if (isLargeView(columnLayout)) {
      return <RenderLargeLayout filteredPrimaryConfig={filteredPrimaryConfig} columnLayout={columnLayout} />;
    }

    return <RenderSmallLayout filteredPrimaryConfig={filteredPrimaryConfig} />;
  }
  return null;
};

export const FiveUpPrimary = React.memo(FiveUpPrimarySection);
